import React, { useState } from "react";
import { ArrowRight, PlayCircle, Sparkles } from "lucide-react";
import { TemplateAutoVideo, TemplateVideoModal } from "./TemplateVideoPreview";

export default function TemplateCard({
  template,
  onUseTemplate,
  categoryLabel = "Featured Collection",
}) {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const openVideo = () => setIsVideoOpen(true);
  const closeVideo = () => setIsVideoOpen(false);

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-[28px] border border-[#ecdde7] bg-white shadow-[0_18px_40px_rgba(80,41,64,0.08)] transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] overflow-hidden bg-[#f9f2f6]">
        <TemplateAutoVideo
          template={template}
          className="h-full w-full"
          mediaClassName="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          fallbackClassName="flex h-full w-full items-center justify-center bg-[#f6e4ed] text-sm font-bold text-[#9a7186]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#8d2f62] shadow-sm">
          {categoryLabel}
        </div>
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            openVideo();
          }}
          className="absolute inset-0 flex items-center justify-center"
          aria-label={`Play ${template.name}`}
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/88 text-[#8d2f62] shadow-xl transition-transform duration-300 group-hover:scale-105">
            <PlayCircle size={34} />
          </span>
        </button>
        <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/80">
            Invitation Film
          </div>
          <h3 className="mt-2 text-xl font-black leading-tight">{template.name}</h3>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-4 p-5">
        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-[#b07c98]">
          <Sparkles size={14} />
          Motion-first preview
        </div>
        <p className="flex-1 text-sm leading-6 text-[#735f6d]">
          Preview the invitation video style first, then customize it for your event.
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              openVideo();
            }}
            className="flex-1 rounded-2xl border border-[#ecd5e2] bg-white px-4 py-3 text-sm font-bold text-[#7f2556] transition-colors hover:border-[#ff0099] hover:text-[#ff0099]"
          >
            Watch Video
          </button>
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onUseTemplate();
            }}
            className="flex flex-1 items-center justify-center gap-2 rounded-2xl bg-[#ff0099] px-4 py-3 text-sm font-bold text-white shadow-lg shadow-[#ff0099]/20 transition-colors hover:bg-black"
          >
            Use Template
            <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <TemplateVideoModal
        template={template}
        isOpen={isVideoOpen}
        onClose={closeVideo}
        onUseTemplate={onUseTemplate}
      />
    </article>
  );
}
